<template>
    <span class="badge ticket-type" :class="`badge-${type}`">
        {{
            type.includes("physical")
                ? trans["is-physical"]
                : trans["is-digital"]
        }}
    </span>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true,
            validator: value => {
                return value.includes("physical") || value.includes("digital");
            }
        },
        trans: {
            type: Object,
            required: true
        }
    }
};
</script>
